import { useEffect, useState } from "react";

interface CountdownProps {
  until: string; // ISO timestamp
  onDone?: () => void;
}

const format = (ms: number): string => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};

/** mm:ss countdown to an ISO deadline; fires onDone once when it reaches zero. */
export function Countdown({ until, onDone }: CountdownProps) {
  const deadline = new Date(until).getTime();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  const remaining = deadline - now;

  useEffect(() => {
    if (remaining <= 0) onDone?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remaining <= 0]);

  return (
    <span className="font-mono text-lg tabular-nums" role="timer" aria-live="off">
      {format(remaining)}
    </span>
  );
}
